<div class="wrapper content-wrapper row" style="background-color: #FFF;" id="style-1">
  <div class="col-12" [ngClass]="{'col-md-4': showLevels, 'col-md-5': !showLevels}" style="background-color: #FFF; padding-top:-7px; margin-top: 15px;">
    <div class="row d-none d-sm-block" style="    margin-top: -2px;
    margin-bottom: -11px;
    padding: 0px 0px 0px 10px;">
      <div class="row">
        <div class="col-6" style="margin-left: 4%">
          <input type="text" class="form-control height-27" style="width: 108%" placeholder="Search.."
          (keyup.enter)="getTenantActivities(false)"
            [(ngModel)]="dealerSearchParam" />
          <div (click)="getTenantActivities(false)" style="padding: 7px;
            cursor: pointer;
            margin-left: 100%;
            height: 28px !important;
            border-radius: 3px;
            cursor: pointer;
            margin-top: -29px;
            width: 28px;
            color: #fff;
            background-color: #7cacd7;">
            <i class="fa fa-search" aria-hidden="true"></i>
          </div>
        </div>

        <div class="col-2">
          <button class="btn height-35" style="    margin-top: -2px;
        height: 28px;" (click)="resetFilter()">Reset</button>
        </div>
        <div class="col-3" style="margin-left: 10px;
      margin-top: -8px;">
          <div>Levels:</div>
          <div><input class="switch" type="checkbox" [(ngModel)]="showLevels" checked /></div>
        </div>
      </div>
    </div>

    <div class="row d-block d-sm-none" style="margin-top: 33px;
    margin-bottom: 12px;
    padding: 0px 0px 0px 10px;">
      <div class="row">
        <div class="col-5" style="margin-left: 25px">
          <input type="text" class="form-control height-27" style="width: 185px" placeholder="Search.."
            [(ngModel)]="dealerSearchParam" />
          <div (click)="getTenantActivities(false)" style="padding: 7px;
            margin-left: 157px;
            height: 28px !important;
            border-radius: 3px;
            cursor: pointer;
            margin-top: -29px;
            width: 28px;
            color: #fff;
            background-color: #7cacd7;">
            <i class="fa fa-search" aria-hidden="true"></i>
          </div>
        </div>

        <div class="col-5">
          <button class="btn height-35" style="    height: 30px;
        margin-top: -3px;" (click)="resetFilter()">Reset</button>
        </div>
      </div>
    </div>

    <div class="br-section-wrapper" style="
    min-height: 141px !important;
    overflow: auto;" *ngIf="!!data && data.length > 0">
      <div id="style-3" class="table-responsive" style="max-height: 207px;">
        <table id=" " class="table table-insurance-inner ">
          <thead>
            <tr>
              <th class="wd-15p th-pd">TAC
                <i class="fa icon-for-plain-text"
                  [ngClass]="{'fa-sort': sortingCurrentStatus.tacStatus == 'norm' || sortingCurrentStatus.tacStatus == 'NA', 
                'fa-sort-asc': sortingCurrentStatus.tacStatus == 'asc', 'fa-sort-desc': sortingCurrentStatus.tacStatus == 'desc'}"
                  (click)="insertSortingObject('tac')"></i>
              </th>
              <th class="wd-30p th-pd" style="width: 24px">Dealer
                <i class="fa icon-for-plain-text"
                  [ngClass]="{'fa-sort': sortingCurrentStatus.dealerStatus == 'norm' || sortingCurrentStatus.dealerStatus == 'NA', 
              'fa-sort-asc': sortingCurrentStatus.dealerStatus == 'asc', 'fa-sort-desc': sortingCurrentStatus.dealerStatus == 'desc'}"
                  (click)="insertSortingObject('dealer')"></i>
              </th>
              <th class="wd-30p th-pd" style="width: 30px">Address
                <i class="fa icon-for-plain-text"
                  [ngClass]="{'fa-sort': sortingCurrentStatus.addressStatus == 'norm' || sortingCurrentStatus.addressStatus == 'NA', 
              'fa-sort-asc': sortingCurrentStatus.addressStatus == 'asc', 'fa-sort-desc': sortingCurrentStatus.addressStatus == 'desc'}"
                  (click)="insertSortingObject('address')"></i>
              </th>
              <th class="wd-5p th-pd" style="width: 27px">City
                <i class="fa icon-for-plain-text"
                  [ngClass]="{'fa-sort': sortingCurrentStatus.cityStatus == 'norm' || sortingCurrentStatus.cityStatus == 'NA', 
              'fa-sort-asc': sortingCurrentStatus.cityStatus == 'asc', 'fa-sort-desc': sortingCurrentStatus.cityStatus == 'desc'}"
                  (click)="insertSortingObject('city')"></i>
              </th>
              <th class="wd-15p th-pd">State
                <i class="fa icon-for-plain-text"
                  [ngClass]="{'fa-sort': sortingCurrentStatus.stateStatus == 'norm' || sortingCurrentStatus.stateStatus == 'NA', 
              'fa-sort-asc': sortingCurrentStatus.stateStatus == 'asc', 'fa-sort-desc': sortingCurrentStatus.stateStatus == 'desc'}"
                  (click)="insertSortingObject('state')"></i>
              </th>
              <th class="wd-15p th-pd" style="width: 12px">Interval
              </th>
              <th class="wd-15p th-pd" *ngIf="hideOrShow">Calc1</th>
              <th class="wd-15p th-pd" *ngIf="hideOrShow">Calc2</th>
              <th class="wd-15p th-pd" *ngIf="hideOrShow">Calc3</th>
            </tr>
          </thead>
          <tbody style="font-size: 10px !important;">
            <tr class="" *ngFor="let item of data" style="padding: 2px; cursor: pointer;"
              [ngClass]="{'selectedTank': previouslySelectedItem == item}" (click)="openModalForDetails(selectionModalForDetails, item); 
              loadDealerData(item.dealer+':'+item.address+':'+item.city)">
              <td><a href="javascript:void(0)">{{item.tac}}</a>
              </td>
              <td>{{item.dealer}}</td>
              <td>{{item.address}}</td>
              <td>{{item.city}}</td>
              <td>{{item.state}}</td>
              <td>{{item.loadInterval}}</td>
              <td *ngIf="hideOrShow">0</td>
              <td *ngIf="hideOrShow">0</td>
              <td *ngIf="hideOrShow">0</td>
            </tr>
          </tbody>
        </table>
      </div>
    </div>

    <div class="row col-12" style="padding-left: 37px;
    padding-right: 3px;
    margin-bottom: 24px;">
      <div style="margin-top: 12px;">
        <b style="color: red; font-size: 11px;">*Red text indicates reading older than 1 day</b>
      </div>
      <div class="table-responsive widget-small" id="style-3" style="margin-top: 6px;">

        <table class="table table-striped">
          <thead style="background-color: #0cccbd">
            <tr>
              <th class="text-center">
                <b>TLS ID</b>
              </th>
              <th class="text-center">
                <b>Product </b>
              </th>
              <th class="text-center">
                <b>Last Inventory </b>
              </th>
              <th class="text-center">
                <b>Inventory </b>
              </th>
              <th class="text-center">
                <b>90% Ullage </b>
              </th>
              <!-- <th class="text-center">
                <b>Last Delivery </b>
              </th> -->
              <th class="text-center">
                <b>Tank Size </b>
              </th>
            </tr>
          </thead>
          <tbody [hidden]="!selectedItem">
            <tr [hidden]="!selectedItem" *ngFor="let item of selectedItem?.tblTanks; let i = index">
              <td><a href="javascript:void(0)" (click)="openModalForTanks(item); 
                loadDealerData(item.dealer)">{{item?.tlstankID}}</a>
              </td>
              <td [hidden]="!selectedItem" class="text-center"
              [ngStyle]="{'color': isOldReading(item?.lastInventoryDate) ? 'red' : 'black' }"
              >
                <a href="javascript:void(0)" (click)="openModalForTanks(item); 
                loadDealerData(item.dealer)">
                  {{item?.tankName}}</a>
              </td>
              <td [hidden]="!selectedItem" class="text-center"
              [ngStyle]="{'color': isOldReading(item?.lastInventoryDate) ? 'red' : 'black' }"
              >{{item?.lastInventoryDate | date: 'MM/dd/yy hh:mm aa'}}
              </td>
              <td [hidden]="!selectedItem" class="text-center"
                [ngStyle]="{'color': isOldReading(item?.lastInventoryDate) ? 'red' : 'black' }">{{item?.lastInventory |
                number : '1.0-0'}}</td>
              <td [hidden]="!selectedItem" class="text-center"
              [ngStyle]="{'color': isOldReading(item?.lastInventoryDate) ? 'red' : 'black' }"
              >{{((item?.tankSize * .9) - item?.lastInventory) | number :
                '1.0-0'}}</td>
              <!-- <td [hidden]="!selectedItem" class="text-center"
              [ngStyle]="{'color': isOldReading(item?.lastInventoryDate) ? 'red' : 'black' }"
              >{{item.lastDeliveryDate | date: 'MM/dd/yy hh:mm aa'}}
              </td> -->
              <td [hidden]="!selectedItem" class="text-center"
              [ngStyle]="{'color': isOldReading(item?.lastInventoryDate) ? 'red' : 'black' }"
              >{{item.tankSize | number : '1.0-0'}}</td>
            </tr>
          </tbody>
        </table>
      </div>


    </div>
    <app-tank-charts [data]="selectedItem" [gradientFill]="gradientFill"></app-tank-charts>

  </div>

  <div class="col-12" [ngClass]="{'col-md-5': showLevels, 'col-md-7': !showLevels}" style="background-color: #FFF; padding-top: 20px; margin-top: 5px;">
    <div class="widget" style="margin-top: -13px;
          padding-top: 10px;
          width: 105%;
          margin-left: -2%;">
      <app-inventory-loads *ngIf="dealerFilter" [contentWrapper]="false" [dealerFilter]="dealerFilter">
      </app-inventory-loads>
    </div>
    <div class="row">
      <!-- <div class="col-6 widget" style="display: block; right: 10px">
        <canvas baseChart 
        [datasets]="barChartData"
        [labels]="barChartLabels"
        [options]="barChartOptions"
        [plugins]="barChartPlugins"
        [legend]="barChartLegend"
        [chartType]="barChartType">
      </canvas>
      </div> -->
      <div class="col-12 row" style="margin-top: -22px;
      margin-bottom: 10px;">
        <div class="col-6" style="font-size: 15px;">
          <b>Days: </b>
          <input name="options" ng-control="options" type="radio" [value]="3" [(ngModel)]="daysDifference"
            (ngModelChange)="openModalForDetails(selectionModalForDetails, previouslySelectedItem)"> 3
          <input name="options" ng-control="options" type="radio" [value]="5" [(ngModel)]="daysDifference"
            (ngModelChange)="openModalForDetails(selectionModalForDetails, previouslySelectedItem)"> 5
          <input name="options" ng-control="options" type="radio" [value]="10" [(ngModel)]="daysDifference"
            (ngModelChange)="openModalForDetails(selectionModalForDetails, previouslySelectedItem)"> 10
          <input name="options" ng-control="options" type="radio" [value]="14" [(ngModel)]="daysDifference"
            (ngModelChange)="openModalForDetails(selectionModalForDetails, previouslySelectedItem)"> 14
          <input name="options" ng-control="options" type="radio" [value]="30" [(ngModel)]="daysDifference"
            (ngModelChange)="openModalForDetails(selectionModalForDetails, previouslySelectedItem)"> 30

        </div>
        <div class="col-6">
          <input type="checkbox" [(ngModel)]="treatTanksSeparately"
            (ngModelChange)="openModalForDetails(selectionModalForDetails, previouslySelectedItem)"> Treat Tanks
          Separately
        </div>
        <!-- <div class="col-6">
          <b>Smoothness: </b> <input style="padding: 1px;
        font-size: 11px;
        border-radius: 6px;
        padding-left: 8px; width: 60px" type="text" [(ngModel)]="smoothnessIndex">
            <button class="btn btn-outline-secondary calendar height-27"
            (click)="openModalForDetails(selectionModalForDetails, previouslySelectedItem)"
            type="button">Apply</button>
        </div> -->
      </div>
      <div class="col-12 row" *ngIf="false">
        <div class="form-group hidden">
          <div class="input-group">
            <input name="datepicker" class="form-control" style="display: none;" ngbDatepicker
              #datepicker="ngbDatepicker" [autoClose]="false"
              (dateSelect)="onDateSelection($event); closeDatePicker && datepicker.toggle()" [displayMonths]="2"
              [dayTemplate]="t" outsideDays="hidden" [startDate]="fromDate">
            <ng-template #t let-date let-focused="focused">
              <span class="custom-day" [class.focused]="focused" [class.range]="isRange(date)"
                [class.faded]="isHovered(date) || isInside(date)" (mouseenter)="hoveredDate = date"
                (mouseleave)="hoveredDate = null">
                {{ date.day }}
              </span>
            </ng-template>
          </div>
        </div>
        <div class="form-group col-6">
          <div class="input-group pointer" (click)="showOverlay = !showOverlay; datepicker.toggle()">
            <label>From : &nbsp;</label>
            <input disabled #dpFromDate class="form-control height-27" placeholder="dd-MM-yy"
              style="width: 97px; color: black; cursor: pointer"
              (click)="showOverlay = !showOverlay; datepicker.toggle()" name="dpFromDate"
              [value]="formatDateForDisplay(fromDate)" (input)="fromDate = validateInput(fromDate, dpFromDate.value);">

            <div class="input-group-append">
              <button class="btn btn-outline-secondary calendar height-27" type="button">
                <i class="fa fa-calendar" aria-hidden="true"></i>
              </button>
            </div>
          </div>
        </div>
        <div class="form-group col-6">
          <div class="input-group pointer" (click)="showOverlay = !showOverlay; datepicker.toggle()">
            <label>To : &nbsp;</label>
            <input #dpToDate disabled class="form-control height-27 pointer" placeholder="yyyy-mm-dd"
              style="width: 97px; color: black" name="dpToDate" [value]="formatDateForDisplay(toDate)"
              (change)="datepicker.toggle()" (input)="toDate = validateInput(toDate, dpToDate.value);">
            <!-- <div class="input-group-append">
              <button class="btn btn-outline-secondary calendar height-27"
                type="button" (click)="datepicker.toggle()">
                <i class="fa fa-calendar" aria-hidden="true"></i>
              </button>
            </div> -->
          </div>
        </div>
      </div>
      <!-- <div class="col-1"></div> -->
      <div class="col-12 widget" style="display: block;">
        <canvas id="baseChart" baseChart [datasets]="lineChartData" [labels]="lineChartLabels"
          [options]="lineChartOptions" [colors]="lineChartColors" [legend]="lineChartLegend" [chartType]="lineChartType"
          [plugins]="lineChartPlugins">
        </canvas>
      </div>
    </div>
  </div>

  <div class="col-md-3 col-12 " *ngIf="showLevels">
    <app-station-tank-levels [iscontainer]="true" [stations]="data" *ngIf="data">
    </app-station-tank-levels>
  </div>
</div>



<ng-template #selectionModalForDetails let-c="close" let-d="dismiss" class="modal-lg">
  <div class="modal-header" style="font-size: 10px !important;">
    <h5 class="modal-title">Stick Readings {{
      (selectedItem?.tblStations?.length > 0 && selectedItem.tblStations[0]?.lastPolled) ? ("for : " +
      selectedItem.tblStations[0]?.lastPolled) : " :"
      }}</h5>
    <button type="button" class="btn" (click)="openModalForGraph(selectionModalForGraph, item)">

      <span aria-hidden="true"><i class="fa fa-line-chart"></i></span>
    </button>
    <button type="button" class="close" aria-label="Close" (click)="d('Cross click')">
      <span aria-hidden="true">&times;</span>
    </button>
  </div>

  <div class="modal-content-cls" style="padding: 19px;">
    <div class="row">
      <div class="col-md-4 col-6">
        <p><b>ID: </b> {{selectedItem?.tblStations?.length > 0 && selectedItem.tblStations[0]?.locationID ?
          selectedItem.tblStations[0]?.locationID : ''}} / {{selectedItem?.tac}}</p>
      </div>
      <div class="col-md-4 col-6">
        <p style="position: absolute;"><b>Customer: </b>{{selectedItem?.billtype?.billingCodeName}}</p>
      </div>
      <div class="col-md-4 col-6">
        <b>Inv Group:</b>
      </div>
    </div>
    <div class="row">
      <div class="col-sm-4 col-6">
        <p class="hidden-sm-up"><b>Phone:</b> {{selectedItem?.tblStations?.length > 0 &&
          selectedItem.tblStations[0]?.phone ? selectedItem.tblStations[0]?.phone : ''}}
      </div>
      <div class="col-md-4 col-6">
        <p style="position: absolute;"><b>Customer: </b>{{selectedItem?.billtype?.billingCodeName}}</p>
      </div>
      <div class="col-md-4 col-6">
        <p><b>Name:</b> {{selectedItem?.tblStations?.length > 0 && selectedItem.tblStations[0]?.name ?
          selectedItem.tblStations[0]?.name : ''}} </p>
      </div>
    </div>
    <div class="row">
      <div class="col-sm-4">
        <p><b>City / State:</b> {{selectedItem?.tblStations?.length > 0 && selectedItem.tblStations[0]?.city ?
          selectedItem.tblStations[0]?.city : ''}} / {{selectedItem?.tblStations?.length > 0 &&
          selectedItem.tblStations[0]?.state ? selectedItem.tblStations[0]?.state : ''}}</p>
      </div>
      <div class="col-md-4 col-4">
        <b>
          <p class="hidden-xs-down">Phone: {{selectedItem?.tblStations?.length > 0 && selectedItem.tblStations[0]?.phone
            ? selectedItem.tblStations[0]?.phone : ''}}</p>
        </b>
      </div>
    </div>

    <div class="table-responsive" style="margin-top: 16px;">
      <table class="table table-striped">
        <thead style="background-color: #0cccbd">
          <tr>
            <th class="text-center">
              Tank ID
            </th>
            <th class="text-center">
              <b>Product </b>
            </th>
            <th class="text-center">
              <b>Date </b>
            </th>
            <th class="text-center">
              <b>Gallons </b>
            </th>
            <th class="text-center">
              <b>Ullage </b>
            </th>
            <th class="text-center">
              <b>Last Delivery </b>
            </th>
            <th class="text-center">
              <b>Tank Size </b>
            </th>
            <!-- <th class="text-center">
            <b>New Gallons </b>
          </th> -->
          </tr>
        </thead>
        <tbody [hidden]="!selectedItem">
          <tr [hidden]="!selectedItem" *ngFor="let item of selectedItem?.tblTanks; let i = index">
            <td [hidden]="!selectedItem" class="text-center">{{item?.counter}}</td>
            <td [hidden]="!selectedItem" class="text-center">{{item?.tankName}}</td>
            <td [hidden]="!selectedItem" class="text-center">{{item?.lastInventoryDate | date: 'MM/dd/yy HH:mm aa'}}
            </td>
            <td [hidden]="!selectedItem" class="text-center">{{item?.lastInventory}}</td>
            <td [hidden]="!selectedItem" class="text-center">{{item?.ullage}}</td>
            <td [hidden]="!selectedItem" class="text-center">{{item.lastDeliveryDate | date: 'MM/dd/yy HH:mm aa'}}</td>
            <td [hidden]="!selectedItem" class="text-center">{{item.tankSize}}</td>
            <!-- <td [hidden]="!selectedItem" class="text-center">
            <input type="text" placeholder="New Gallon" class="form-control" [(ngModel)]="tblReadings[i].gallons">
          </td> -->
          </tr>
        </tbody>
      </table>
    </div>
    <!-- <div class="table-responsive">
    <table class="table table-striped hidden-sm-up">
      <thead style="background-color: #0cccbd; color: #FFF;">
        <tr>
          <th style="" class="text-center">
            <b>Tank ID</b>
          </th>
          <th style="" class="text-center">
            <b>Product</b>
          </th>
          <th style="" class="text-center">
            <b>Gallons</b>
          </th>
        </tr>
      </thead>

      <tbody [hidden]="!selectedItem">
        <tr [hidden]="!selectedItem" *ngFor="let item of selectedItem?.tblTanks; let i = index">
          <td [hidden]="!selectedItem" class="text-center">{{item?.counter}}</td>
          <td [hidden]="!selectedItem" class="text-center">{{item?.tankName}}</td>
          <td [hidden]="!selectedItem" class="text-center">
            <input type="text" placeholder="New Gallon" [(ngModel)]="tblReadings[i].gallons" class="form-control">
          </td>
        </tr>
      </tbody>
    </table>
  </div> -->
  </div>


  <div class="modal-footer">
    <button type="button" class="btn btn-secondary" (click)="c('Close click')">Close</button>
  </div>
</ng-template>

<ng-template #selectionModalForGraph let-c="close" let-d="dismiss" class="modal-lg">
  <div class="modal-header">
    Graph
    <button type="button" class="close" aria-label="Close" (click)="d('Cross click')">
      <span aria-hidden="true">&times;</span>
    </button>
  </div>

  <div style="display: block;">
    <canvas baseChart [datasets]="lineChartData" [labels]="lineChartLabels" [options]="lineChartOptions"
      [colors]="lineChartColors" [legend]="lineChartLegend" [chartType]="lineChartType" [plugins]="lineChartPlugins">
    </canvas>
  </div>
  <div class="chart-wrapper col-6">

  </div>



  <div class="modal-footer">
    <button type="button" class="btn btn-secondary" (click)="c('Close click')">Close</button>
  </div>
</ng-template>